export const LOCATIONS = {
  'Казахстан': [
    'Алматы', 'Астана', 'Шымкент', 'Актобе', 'Атырау', 'Актау', 'Павлодар',
    'Усть-Каменогорск', 'Семей', 'Тараз', 'Костанай', 'Кызылорда', 'Уральск',
    'Петропавловск', 'Талдыкорган', 'Туркестан', 'Экибастуз', 'Рудный',
    'Темиртау', 'Жанаозен', 'Балхаш', 'Кокшетау', 'Жезказган', 'Сатпаев',
    'Щучинск', 'Капчагай', 'Конаев', 'Алтай', 'Риддер', 'Аксай',
  ],
  'Россия': [
    'Москва', 'Санкт-Петербург', 'Новосибирск', 'Екатеринбург', 'Нижний Новгород',
    'Казань', 'Самара', 'Омск', 'Красноярск', 'Уфа', 'Ростов-на-Дону',
    'Волгоград', 'Пермь', 'Краснодар', 'Воронеж', 'Челябинск', 'Тюмень',
    'Тольятти', 'Ижевск', 'Барнаул', 'Иркутск', 'Хабаровск', 'Ярославль',
    'Владивосток', 'Махачкала', 'Томск', 'Оренбург', 'Кемерово', 'Новокузнецк',
    'Рязань', 'Астрахань', 'Пенза', 'Набережные Челны', 'Липецк', 'Тула',
    'Киров', 'Чебоксары', 'Калининград', 'Брянск', 'Курск', 'Иваново',
    'Сочи', 'Ставрополь', 'Улан-Удэ', 'Тверь', 'Саратов', 'Белгород',
  ],
  'Узбекистан': [
    'Ташкент', 'Самарканд', 'Бухара', 'Наманган', 'Андижан', 'Фергана',
    'Нукус', 'Карши', 'Термез', 'Навои', 'Коканд', 'Маргилан', 'Джизак',
  ],
  'Кыргызстан': [
    'Бишкек', 'Ош', 'Джалал-Абад', 'Каракол', 'Нарын', 'Талас', 'Баткен',
  ],
  'Таджикистан': [
    'Душанбе', 'Худжанд', 'Куляб', 'Курган-Тюбе', 'Хорог', 'Турсунзаде',
  ],
  'Туркменистан': [
    'Ашхабад', 'Туркменабад', 'Мары', 'Дашогуз', 'Туркменбаши', 'Балканабат',
  ],
  'Азербайджан': [
    'Баку', 'Гянджа', 'Сумгайыт', 'Мингечевир', 'Нахчыван', 'Ширван',
  ],
  'Грузия': [
    'Тбилиси', 'Батуми', 'Кутаиси', 'Рустави', 'Зугдиди', 'Гори',
  ],
  'Армения': [
    'Ереван', 'Гюмри', 'Ванадзор', 'Абовян', 'Раздан', 'Абовян',
  ],
  'Беларусь': [
    'Минск', 'Брест', 'Гомель', 'Гродно', 'Витебск', 'Могилёв', 'Бобруйск',
  ],
  'Украина': [
    'Киев', 'Харьков', 'Одесса', 'Днепр', 'Запорожье', 'Львов', 'Кривой Рог',
    'Николаев', 'Мариуполь', 'Луганск', 'Херсон', 'Черновцы', 'Полтава',
    'Хмельницкий', 'Черкассы', 'Сумы', 'Житомир', 'Ровно', 'Ивано-Франковск',
  ],
  'Молдова': [
    'Кишинёв', 'Тирасполь', 'Бельцы', 'Бендеры', 'Рыбница',
  ],
  'ОАЭ': [
    'Дубай', 'Абу-Даби', 'Шарджа', 'Аджман', 'Рас-эль-Хайма',
  ],
  'Германия': [
    'Берлин', 'Мюнхен', 'Гамбург', 'Кёльн', 'Франкфурт', 'Штутгарт',
    'Дюссельдорф', 'Дортмунд', 'Эссен', 'Лейпциг', 'Бремен', 'Дрезден',
  ],
  'США': [
    'Нью-Йорк', 'Лос-Анджелес', 'Чикаго', 'Хьюстон', 'Феникс', 'Сан-Антонио',
    'Сан-Диего', 'Даллас', 'Сан-Хосе', 'Остин', 'Майами', 'Лас-Вегас',
  ],
  'Турция': [
    'Стамбул', 'Анкара', 'Измир', 'Бурса', 'Анталья', 'Адана', 'Конья',
    'Газиантеп', 'Мерсин', 'Диярбакыр', 'Трабзон', 'Эскишехир',
  ],
  'Китай': [
    'Пекин', 'Шанхай', 'Гуанчжоу', 'Шэньчжэнь', 'Чэнду', 'Ханчжоу',
    'Ухань', 'Сиань', 'Нанкин', 'Тяньцзинь', 'Чунцин', 'Харбин',
  ],
};

export const COUNTRY_LIST = Object.keys(LOCATIONS);

export const PHONE_PLACEHOLDERS = {
  'Казахстан':    '+7 (777) 777-77-77',
  'Россия':       '+7 (999) 123-45-67',
  'Узбекистан':   '+998 90 123 45 67',
  'Кыргызстан':   '+996 700 123 456',
  'Таджикистан':  '+992 900 12 34 56',
  'Туркменистан': '+993 65 12 34 56',
  'Азербайджан':  '+994 50 123 45 67',
  'Грузия':       '+995 599 12 34 56',
  'Армения':      '+374 91 12 34 56',
  'Беларусь':     '+375 29 123-45-67',
  'Украина':      '+380 67 123 45 67',
  'Молдова':      '+373 69 123 456',
  'ОАЭ':          '+971 50 123 4567',
  'Германия':     '+49 151 12345678',
  'США':          '+1 (555) 234-5678',
  'Турция':       '+90 532 123 45 67',
  'Китай':        '+86 138 0013 8000',
};

// Phone masks: # = user digit, everything else = literal (auto-inserted)
export const PHONE_FORMATS = {
  'Казахстан':    '+7 (###) ###-##-##',
  'Россия':       '+7 (###) ###-##-##',
  'Узбекистан':   '+998 (##) ###-##-##',
  'Кыргызстан':   '+996 ### ##-##-##',
  'Таджикистан':  '+992 ## ###-##-##',
  'Туркменистан': '+993 ## ##-##-##',
  'Азербайджан':  '+994 ## ###-##-##',
  'Грузия':       '+995 ### ##-##-##',
  'Армения':      '+374 ## ##-##-##',
  'Беларусь':     '+375 (##) ###-##-##',
  'Украина':      '+380 (##) ###-##-##',
  'Молдова':      '+373 ## ###-###',
  'ОАЭ':          '+971 ## ### ####',
  'Германия':     '+49 ### ########',
  'США':          '+1 (###) ###-####',
  'Турция':       '+90 (###) ###-##-##',
  'Китай':        '+86 ### #### ####',
};

// Returns the literal prefix of a mask (everything before the first #)
export function getMaskPrefix(mask) {
  const idx = mask.indexOf('#')
  return idx >= 0 ? mask.slice(0, idx) : mask
}

// Applies mask to user-supplied digits (only the local part, not the country code)
export function applyPhoneMask(userDigits, mask) {
  let result = ''
  let di = 0
  for (let mi = 0; mi < mask.length; mi++) {
    if (mask[mi] === '#') {
      if (di >= userDigits.length) break
      result += userDigits[di++]
    } else {
      // Only add literal char if there are still digits ahead to display
      const nextHash = mask.indexOf('#', mi)
      if (nextHash === -1 || di < userDigits.length) {
        result += mask[mi]
      }
    }
  }
  return result
}

// Formats a raw phone string (e.g. from DB) into a mask.
// Handles: +7XXXXXXXXXX, 7XXXXXXXXXX, 8XXXXXXXXXX, plain 10 digits, etc.
export function formatExistingPhone(phone, mask) {
  if (!phone || !mask) return phone || ''
  const prefix = getMaskPrefix(mask)
  const prefixDigits = prefix.replace(/\D/g, '')
  const localDigitCount = (mask.match(/#/g) || []).length
  const allDigits = String(phone).replace(/\D/g, '')

  let userDigits
  if (prefixDigits && allDigits.startsWith(prefixDigits)) {
    // Exact country code match: strip it and take local digits
    userDigits = allDigits.slice(prefixDigits.length)
  } else if (allDigits.length > localDigitCount) {
    // More digits than local count → strip leading trunk/country code
    // (handles 8XXXXXXXXXX, 00XXXXXXXXXX, etc.)
    userDigits = allDigits.slice(allDigits.length - localDigitCount)
  } else {
    userDigits = allDigits
  }

  return applyPhoneMask(userDigits.slice(0, localDigitCount), mask)
}
